import packageAxios from "~common/assets/js/packageAxios.js";
// import * as MockData from "../../MockData/mockData.js";
const actions = {
  /****---------------------------------------------****
   **** 用户信息相关模块 ****
   ****---------------------------------------------****/
  /**
   * 获取省份信息数据列表
   * @param {Object} context 仓库命令
   */
  getProvinceList(context, params) {
    return packageAxios("", "", params, window.TAL_UC.getProvinces).then(res => {
      return res;
    });
  },

  /**
   * 获取城市信息数据列表
   * @param {Object} context 仓库命令
   */
  getCityList(context, params) {
    return packageAxios("", "", params, window.TAL_UC.getCitys).then(res => {
      return res;
    });
  },

  /**
   * 获取区县信息数据列表
   * @param {Object} context 仓库命令
   */
  getCountyList(context, params) {
    return packageAxios("", "", params, window.TAL_UC.getCounty).then(res => {
      return res;
    });
  },

  // 根据ip获取位置
  getProvincePosition() {
    return packageAxios("/web/position/ip", "POST").then(res => {
      return res;
    });
  },

  // 获取年级列表
  getGradeList() {
    return packageAxios("/web/grade/list", "POST").then(res => {
      return res;
    });
  },

  // 获取学校列表
  getSchoolList(context, params) {
    return packageAxios("/web/school/list", "POST", params).then(res => {
      return res;
    });
  },

  // 获取用户班级信息
  getClassesInfo(context, params) {
    return packageAxios("/web/user/classes/info", "POST", params).then(res => {
      return res;
    });
  },

  // 保存操作
  saveUserClasses(context, params) {
    return packageAxios("/web/user/classes/save", "POST", params).then(res => {
      return res;
    });
  }
};

export default actions;



// WEBPACK FOOTER //
// ./common/commonModule/passport/vuex/passport/actions.js